import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import lookups from '@/assets/json/clientLookups.json'
import router from '@/router'
import apiHelperService from '@/services'
import { useGlobalStore } from '@/stores/global'

const typingCenterPreload = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const authStore = useAuthStore()
  const { serviceConfig } = globalStore.startedService

  if (!authStore.isUserTypingCenter) {
    return
  }

  if (serviceConfig.hideIdentity) {
    formStore.extraMap = {
      ...formStore.extraMap,
      hideIdentity: serviceConfig.hideIdentity,
      isUsingCardReader: false,
      isUsingSponsorEIDA: false
    }
  }
}

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '', withException = '' } = router.currentRoute.value.query

  formStore.extraMap = {
    ...formStore.extraMap,
    disableSponsorType: false,
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true'
  }
}
const initInfo = async () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const {
    application: { gcc_citizen, resident },
    sponsoredCategoryType: { allSponsoreds },
    fileStatusType,
    escapeReportsStatusType
  } = lookups
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    const { englishFullName = '', arabicFullName = '', unifiedNumber = '' } = res || {}
    if (authStore.user.applicationId == gcc_citizen) {
      formStore.draft.request.sponsorTypeId = 5
      formStore.extraMap.disableSponsorType = true
    }
    if (authStore.user.applicationId == resident) {
      formStore.draft.request.sponsorTypeId = 4
      formStore.extraMap.disableSponsorType = true
    }
    formStore.draft.request = {
      ...formStore.draft.request,
      sponsorName: arabicFullName,
      sponsorNumber: unifiedNumber,
      arabicFullName: arabicFullName,
      englishFullName: englishFullName,
      sponsoredCategoryTypeId: allSponsoreds,
      fileStatusTypeId: fileStatusType.all,
      escapeReportsStatusTypeId: escapeReportsStatusType.all
    }
  }
}
export default async function () {
  try {
    await typingCenterPreload()
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use79Preload error: ', error)
  }
}
